﻿import Alpine from '/src/app.js';
import blocks from './blocks.js';
import * as forms from '/src/components/forms/index.js';

forms.init(Alpine);

Alpine.plugin(blocks);
Alpine.start();

